import { useGlobalStore } from '@/stores/globalStore';

import useErrorHandling from '@/composables/api/useErrorHandling';
import useCreateDefaultsFromApi from '@/composables/api/useCreateDefaultsFromApi';
import useAxnab from '@/composables/identity/useAxnab';
import useSessionStorage from '@/composables/storage/useSessionStorage';

const DIRECT_VISIT_EXEMPT_KEY = 'banxa_direct_visit_exempt';

const generateErrorHtml = (merch) => {
    const { name, returnUrl } = merch;
    const errorHtml = `<p>
        To place an order with Banxa on ${name}, please<br />
        visit ${name}'s
        <a href="${returnUrl}" rel="noopener noreferrer">Buy Crypto</a>
        page directly.<br />
      </p>
      <p>For more information, please visit <a href="https://support.banxa.com/en/support/home" rel="noopener noreferrer">our support page</a>.</p>`;
      return errorHtml;
  };

  const handleDirectVisit = () => {
    const { checkSessionStorage, bindSessionStorage } = useSessionStorage();

    try {
      if (checkSessionStorage(DIRECT_VISIT_EXEMPT_KEY, false) === true) {
        return;
      }
    } catch {
      // fall through to live checks
    }

    const globalStore = useGlobalStore();
    const currentUrl = new URL(window.location);
    const splitUrl = currentUrl.pathname.split('/');
    const { handleErrorInSpaFlow } = useErrorHandling();
    const { isAnApiOrder } = useCreateDefaultsFromApi();
    const { merchant } = globalStore.global;
    const { isAxnab } = useAxnab();

    const urlsToSkipDirectVist = [
      'status',
      'coindeposit',
      'recovery',
      'callback', /* for payment callbacks */
    ];

    // to allow swap session from Banxa to Axnab
    const hasUserRedirectedToAxnab = !!currentUrl.searchParams.get('session')
    && isAxnab();

    if (
      isAnApiOrder()
      || hasUserRedirectedToAxnab
      || merchant?.allowDirectVisit
      || urlsToSkipDirectVist.some((url) => splitUrl.includes(url))
    ) {
      try {
        bindSessionStorage(DIRECT_VISIT_EXEMPT_KEY, true);
      } catch {
        // still allow this visit
      }
      return;
    }

    handleErrorInSpaFlow('dontAllowDirectVisit', generateErrorHtml(merchant));
  };

export default handleDirectVisit;
